import { render, staticRenderFns } from "./viewRecommend.vue?vue&type=template&id=baf26fd8&scoped=true&"
import script from "./viewRecommend.vue?vue&type=script&lang=js&"
export * from "./viewRecommend.vue?vue&type=script&lang=js&"
import style0 from "./viewRecommend.vue?vue&type=style&index=0&id=baf26fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf26fd8",
  null
  
)

export default component.exports